import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { Button, TextInput, Image, Anchor } from "hesus-ui-kit";
import axios from "axios";
import * as moment from "moment";
import PropTypes from "prop-types";
import "../../AddEditQuote.scss";
import { renderPriceWithCurrencyWithoutUnit, addSpace } from "@utils/utils";
import SelectSellingPrice from "./SelectSellingPrice";
import QuoteAction from "./QuoteAction";
import QuoteItems from "./QuoteItems";
import AddEditSellingPrice from "../../../../SellingPrice/AddEditSellingPrice";
import errorIcon from "@icons/ic-error.svg";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
  RequiredMessage,
} from "@utils/extra-style";
import {
  Title,
  FlexRowHeader,
  GridRow,
  ErrorDiv,
  ExchangeInputStyles,
} from "../../AddEditQuote.styled";

import {
  HeaderWrapperTable,
  EnquiryIdHyphen,
  MargingDiv,
  MarginGridSubItem,
  QuoteServiceInfo,
  QuoteServicePadding,
  ServiceInfo,
  ExchangeRateConatiner,
  ExchangeRateLabel,
} from "./QuoteServices.styled";

const QuoteServices = (props) => {
  const {
    t,
    statusDraft,
    siteId,
    selectedSellingPrice,
    setSelectedSellingPrice,
    siteData,
    data,
    serviceList,
    setServiceList,
    requestStatus,
    setRequestStatus,
    calculateMargin,
    setCalculateMargin,
    formData,
    currencyPosition,
    currency,
    itemsErrorMessage,
    setExchangeCurrency,
    exchangeCurrency,
    currencyList,
    exchangeRate,
    setExchangeRate,
  } = props;

  const [enquiryList, setEnquiryList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isSelectSellingPricePopupVisible, setSelectSellingPricePopupVisible] =
    useState(false);
  const [isEditSellingPricePopupVisible, setIsEditSellingPricePopupVisible] =
    useState(false);
  const [isAddSellingPricePopupVisible, setIsAddSellingPricePopupVisible] =
    useState(false);
  const [selectedSolutionIds, setSelectedSolutionIds] = useState([]);
  const [sellingPriceArray, setSellingPriceArray] = useState([]);
  const [currentSellingPrice, setCurrentSellingPrice] = useState([]);
  const [enquiryData, setEnquiryData] = useState([]);
  const [closeAllPopUp, setCloseAllPopUp] = useState(false);
  const [editSellingPriceId, setEditSellingPriceId] = useState();

  const addSellingPrice = () => {
    setSelectSellingPricePopupVisible(true);
  };

  const editSellingPrice = (sellingPriceId) => {
    setEditSellingPriceId(sellingPriceId);
    setSelectSellingPricePopupVisible(false);
    setIsAddSellingPricePopupVisible(false);
    setIsEditSellingPricePopupVisible(true);
    setCloseAllPopUp(false);
  };

  const editQuoteSellingPrice = (sellingPriceId) => {
    setEditSellingPriceId(sellingPriceId);
    setSelectSellingPricePopupVisible(false);
    setIsAddSellingPricePopupVisible(false);
    setIsEditSellingPricePopupVisible(true);
    setCloseAllPopUp(true);
  };

  const addNewSellingPrice = () => {
    setSelectSellingPricePopupVisible(false);
    setIsAddSellingPricePopupVisible(true);
    setIsEditSellingPricePopupVisible(false);
  };

  const closeSellingPriceEditPopup = () => {
    setSelectSellingPricePopupVisible(true);
    setIsAddSellingPricePopupVisible(false);
    setIsEditSellingPricePopupVisible(false);
    if (closeAllPopUp) {
      setSelectSellingPricePopupVisible(false);
    }
  };

  const fetchEnquiryInfo = () => {
    setLoading(true);
    axios
      .get(
        `/enquiries?siteId=${siteId}&limit=-1&dataLevel=1&orderColumn=id&orderBy=asc&dependancies=["sellingPrices"]&step=[1,2,5,9]`
      )
      .then((response) => {
        setEnquiryList(response?.data?.enquiries);
        setLoading(false);
      })
      .catch((error) => {
        setEnquiryList([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchEnquiryInfo();
  }, []);

  const onRefreshData = () => {
    fetchEnquiryInfo();
    addSellingPrice();
  };

  useEffect(() => {
    const solutionIds = [];
    const statusList = [];
    const selingPriceObj = [];
    let editSelingPriceObj = [];
    enquiryList.map((data) => {
      statusList[data.id] = data.service;
      data.sellingPrices.map((sellingPricesList) => {
        if (
          parseInt(sellingPricesList.id, 10) ===
          parseInt(editSellingPriceId, 10)
        ) {
          editSelingPriceObj = sellingPricesList;
        }

        solutionIds[sellingPricesList.id] = [];
        selingPriceObj[sellingPricesList.id] = [];
        sellingPricesList.services.map((service) => {
          solutionIds[sellingPricesList.id][
            parseInt(service.hesusService.id, 10)
          ] = [];
          selingPriceObj[sellingPricesList.id] = service;
          service.solutions.map((solutionInfo) => {
            solutionIds[sellingPricesList.id][
              parseInt(service.hesusService.id, 10)
            ].push(solutionInfo.solution.id);
          });
        });
      });
    });
    setSelectedSolutionIds(solutionIds);
    setSellingPriceArray(selingPriceObj);
    setRequestStatus(statusList);

    const index = selectedSellingPrice.indexOf(editSellingPriceId);
    if (index !== -1) {
      addNewService(editSelingPriceObj, editSellingPriceId);
    }

    setEditSellingPriceId();
    setCalculateMargin(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enquiryList]);

  const updateEnquiryInfo = (enquiryId) => {
    const selectedEnquiry = enquiryList.find(
      (enquiry) => parseInt(enquiryId, 10) === parseInt(enquiry.id, 10)
    );
    setEnquiryData(selectedEnquiry);
  };

  useEffect(() => {
    const serviceData = [];
    if (data?.length > 0) {
      data.map((service) => {
        const serviceDataObject = {
          id: service.id,
          label: service.label,
          labelError: "",
          enquiryId: service?.sellingPrice?.requestId,
          sellingPriceId: service?.sellingPrice?.id,
          catalogId: service?.sellingPrice?.hesusCatalog?.id,
          currency: service?.currency,
          items: [],
        };
        if (service?.items?.length > 0) {
          service?.items.map((item) => {
            const serviceItems = {
              id: item.id,
              sellingPriceItemId: item.sellingPriceItem?.id,
              hesusCatalogServiceId:
                item?.sellingPriceItem?.hesusCatalogService?.id,
              hesusService: item.sellingPriceItem?.hesusService,
              label: item.label,
              labelError: "",
              product: item.product,
              transport: item.transport,
              comment: item.sellingPriceItem?.comment,
              quantity: item?.quantity,
              unit: item?.unit,
              unitPrice: item.itemSellingPrice,
              purchasePrice: item.sellingPriceItem?.purchasePrice,
              totalPrice: (item?.quantity ?? 0) * (item?.itemSellingPrice ?? 0),
              currency: service?.currency ?? service?.sellingPrice?.currency,
              sellingPriceExcludedTax: item.sellingPriceExcludedTax,
              sellingPriceIncludedTax: item.sellingPriceIncludedTax,
              vatRate: item.vatRate,
              margin: parseFloat(item?.margin) * parseInt(item?.quantity, 10),
              marginRate: item?.margin,
              calculateMarginRate:
                parseFloat(item?.margin) *
                parseFloat(item.sellingPriceExcludedTax),
            };
            serviceDataObject.items.push(serviceItems);
          });
        }
        serviceData.push(serviceDataObject);
      });
    }
    setServiceList(serviceData);
    setCalculateMargin(true);
  }, [data]);

  const onSubLabelChange = (
    e,
    sellingPriceItemId,
    enquiryId,
    sellingPriceId
  ) => {
    serviceList.map((service, index) => {
      if (
        parseInt(service.enquiryId, 10) === parseInt(enquiryId, 10) &&
        parseInt(service.sellingPriceId, 10) === parseInt(sellingPriceId, 10)
      ) {
        service.items.map((item, itemIndex) => {
          if (
            parseInt(item.sellingPriceItemId, 10) ===
            parseInt(sellingPriceItemId, 10)
          ) {
            serviceList[index].items[itemIndex].label = e.target.value;
            serviceList[index].items[itemIndex].labelError = "";
          }
        });
        setServiceList([...serviceList]);
      }
    });
  };

  const onLabelChange = (e, enquiryId, sellingPriceId) => {
    const responseData = serviceList.map((service) => {
      const tempData = { ...service };
      if (
        parseInt(service.enquiryId, 10) === parseInt(enquiryId, 10) &&
        parseInt(service.sellingPriceId, 10) === parseInt(sellingPriceId, 10)
      ) {
        tempData.label = e.target.value;
        tempData.labelError = "";
      }
      return tempData;
    });
    setServiceList([...responseData]);
  };

  const getCurrentSellingPirceData = (enquiryId, sellingPriceId) => {
    let sellingPriceInfo = [];
    const currentEnquiryInfo = enquiryList.find(
      (enquiry) => enquiry.id === enquiryId
    );
    if (currentEnquiryInfo) {
      sellingPriceInfo = currentEnquiryInfo.sellingPrices.find(
        (sellingPriceData) => sellingPriceData.id === sellingPriceId
      );
    }
    return sellingPriceInfo;
  };

  const getCurrentEnquiryData = (enquiryId) => {
    const currentEnquiryInfo = enquiryList.find(
      (enquiry) => enquiry.id === enquiryId
    );
    return currentEnquiryInfo;
  };

  const onServiceDelete = (sellingPriceId) => {
    const services = serviceList.filter(
      (service) => service.sellingPriceId !== sellingPriceId
    );
    setServiceList(services);

    const selectedSellingPriceArr = selectedSellingPrice.filter(
      (id) => id !== sellingPriceId
    );
    setSelectedSellingPrice(selectedSellingPriceArr);
  };

  const addNewService = (sellingPrice, sellingPriceId = "") => {
    let serviceData = serviceList;
    if (sellingPriceId) {
      serviceData = serviceList.filter(
        (service) => service.sellingPriceId !== sellingPriceId
      );
    }
    const serviceDataObject = {
      id: null,
      label: sellingPrice.label ?? "",
      labelError: "",
      enquiryId: sellingPrice?.requestId,
      sellingPriceId: sellingPrice?.id,
      catalogId: sellingPrice?.hesusCatalog?.id,
      currency: sellingPrice?.currency,
      items: [],
    };
    if (sellingPrice?.services?.length > 0) {
      sellingPrice?.services.map((item) => {
        const serviceItems = {
          id: "",
          labelError: "",
          hesusCatalogServiceId: item?.hesusCatalogService?.id,
          sellingPriceItemId: item?.id,
          hesusService: item?.hesusService,
          label: item?.hesusService?.name ?? "",
          product: item.product,
          transport: item.transportType,
          comment: item?.comment,
          quantity: item?.quantity,
          unit: item?.unit,
          unitPrice: item?.unitPrice,
          totalPrice: item?.totalPrice,
          currency: sellingPrice?.currency,
          purchasePrice: item?.purchasePrice,
          margin: item?.margin * item?.quantity,
          marginRate: item?.marginRate,
          calculateMarginRate:
            parseFloat(item?.margin) * parseFloat(item?.quantity) * 100,
          sellingPriceExcludedTax: item?.totalPrice,
          sellingPriceIncludedTax: formData.taxRate.value
            ? parseFloat(item?.totalPrice) * (1 + formData.taxRate.value)
            : 0,
          vatRate: formData.taxRate.value,
        };
        serviceDataObject.items.push(serviceItems);
      });
    }
    serviceData.push(serviceDataObject);
    setServiceList([...serviceData]);
  };

  const onClose = (type) => {
    if (type === "validate") {
      selectedSellingPrice.map((sellingPrice) => {
        const serviceInfo = serviceList.find(
          (service) =>
            parseInt(sellingPrice, 10) === parseInt(service.sellingPriceId, 10)
        );
        if (!serviceInfo) {
          addNewService(sellingPriceArray[sellingPrice]);
        }
      });

      serviceList.map((service) => {
        const index = selectedSellingPrice.indexOf(service.sellingPriceId);
        if (index === -1) {
          onServiceDelete(service.sellingPriceId);
        }
      });
      setCalculateMargin(true);
    }

    if (type === "close") {
      const newSelectedSellingPrice = [];
      serviceList.map((sellingPrice) => {
        newSelectedSellingPrice.push(sellingPrice.sellingPriceId);
      });
      setSelectedSellingPrice(newSelectedSellingPrice);
    }
    setSelectSellingPricePopupVisible(false);
  };

  const onExchangeRateChange = (e, currencyId) => {
    let rates = [];

    const rateInfoData = exchangeRate.find(
      (rate) => parseInt(rate.id, 10) === parseInt(currencyId, 10)
    );
    if (rateInfoData) {
      rates = exchangeRate.map((rateInfo) => {
        const rateObject = { ...rateInfo };
        if (rateInfo.id === currencyId) {
          rateObject.rate = e.target.value;
          rateObject.error = "";
        }
        return rateObject;
      });
    } else {
      rates = exchangeRate;
      rates.push({
        id: currencyId,
        rate: e.target.value,
        error: "",
        exchangeRateId: null,
      });
    }
    setExchangeRate([...rates]);
    setCalculateMargin(true);
  };

  const getExchangeValue = (currencyId) => {
    const rateInfo = exchangeRate.find((rate) => rate.id === currencyId);
    return rateInfo ? String(rateInfo?.rate) : "";
  };

  const getExchangeError = (currencyId) => {
    const rateInfo = exchangeRate.find((rate) => rate.id === currencyId);
    return rateInfo ? rateInfo?.error : "";
  };

  const checkAllExchangeHasValue = () => {
    let dataLegth = 1;
    if (exchangeCurrency?.length > 0 && exchangeRate?.length > 0) {
      const rateInfo = exchangeRate.find((rateData) => rateData.rate === "");
      dataLegth = rateInfo ? rateInfo?.length : 0;
    }
    return dataLegth;
  };

  const getConvertedPrice = (currencyId, price) => {
    const rateInfo = exchangeRate.find((rate) => rate.id === currencyId);
    return rateInfo ? rateInfo?.rate * price : price;
  };

  useEffect(() => {
    const currencyArray = [];
    const rates = [];
    const quoteCurrency = [];

    if (serviceList?.length > 0) {
      serviceList.map((service) => {
        const data =
          service.items?.length > 0 &&
          service.items.map((item) => {
            if (
              quoteCurrency.indexOf(parseInt(item?.currency?.id, 10)) === -1 &&
              parseInt(formData?.currency?.value, 10) !==
                parseInt(item?.currency?.id, 10)
            ) {
              quoteCurrency.push(parseInt(item?.currency?.id, 10));
            }
          });
      });
    }
    if (quoteCurrency?.length > 0) {
      quoteCurrency.map((currencyInfo) => {
        currencyArray.push(parseInt(currencyInfo, 10));

        const rateInfoData = exchangeRate.find(
          (rate) => rate.id === currencyInfo
        );
        if (rateInfoData) {
          rates.push(rateInfoData);
        } else {
          rates.push({
            id: currencyInfo,
            rate: "",
            error: "",
            exchangeRateId: null,
          });
        }
      });
    }
    setExchangeCurrency([...currencyArray]);
    setExchangeRate([...rates]);
  }, [formData.currency.value, serviceList]);

  return (
    <>
      <FlexRowHeader>
        <Title>{t("QUOTE_SERVICES")}</Title>
        {!statusDraft && (
          <Button
            onClick={addSellingPrice}
            styles={{
              backgroundColor: "white",
              color: "#008395",
              border: "1px solid #008395",
              height: "auto",
              width: "auto",
              padding: "1px 4px 1px 4px",
              "&:hover": {
                backgroundColor: "white",
              },
            }}
          >
            {t("QUOTE_ADD_SERVICES")}
          </Button>
        )}
      </FlexRowHeader>
      <QuoteServiceInfo>
        <QuoteServicePadding>
          {serviceList?.length > 0 &&
            serviceList.map((service, serviceIndex) => {
              return (
                <React.Fragment key={"quoteEnquiryService" + serviceIndex}>
                  <GridRow marginBottom="0px">
                    <HeaderWrapperTable>
                      <GridRow column="auto 70% 1fr" marginBottom="0px;">
                        <Title marginTop="6px">
                          <Anchor
                            url={`/site/view/${siteId}/enquiry-view-${service.enquiryId}`}
                            target="_blank"
                            className="add-quote__quote-service-link"
                          >
                            {t("ENQUIRY") + " #" + service?.enquiryId}
                          </Anchor>
                          <EnquiryIdHyphen color="#0A4986" decoration="none">
                            {" "}
                            -{" "}
                          </EnquiryIdHyphen>
                        </Title>
                        <TextInput
                          type="text"
                          onChange={(e) => {
                            onLabelChange(
                              e,
                              service?.enquiryId,
                              service?.sellingPriceId
                            );
                          }}
                          name="quote-service-label"
                          id="quote-service-label"
                          value={String(service?.label) || ""}
                          errorStyles={{ "font-style": "italic" }}
                          disabled={statusDraft}
                          labelStyles={
                            service?.labelError !== ""
                              ? labelStylesError
                              : labelStyles
                          }
                          inputStyles={
                            service?.labelError !== ""
                              ? inputStylesError
                              : inputStyles
                          }
                          containerStyles={{
                            marginBottom:
                              service?.labelError !== "" ? "15px" : "0px",
                          }}
                          error={service?.labelError}
                        />
                        <QuoteAction
                          currentEnquiryData={getCurrentEnquiryData(
                            service.enquiryId
                          )}
                          editSellingPrice={editQuoteSellingPrice}
                          setCurrentSellingPrice={setCurrentSellingPrice}
                          setEnquiryData={setEnquiryData}
                          currentSellingPirceData={getCurrentSellingPirceData(
                            service.enquiryId,
                            service.sellingPriceId
                          )}
                          statusDraft={statusDraft}
                          onServiceDelete={onServiceDelete}
                          setCalculateMargin={setCalculateMargin}
                        />
                      </GridRow>
                    </HeaderWrapperTable>
                  </GridRow>
                  <QuoteItems
                    enquiryId={service.enquiryId}
                    sellingPriceId={service.sellingPriceId}
                    itemList={service.items}
                    quoteServiceCurrency={service?.currency}
                    statusDraft={statusDraft}
                    onSubLabelChange={onSubLabelChange}
                    mainCurrency={formData.currency.value}
                    getExchangeValue={getExchangeValue}
                    currency={currency}
                    currencyPosition={currencyPosition}
                    getConvertedPrice={getConvertedPrice}
                  />
                </React.Fragment>
              );
            })}
          {serviceList.length === 0 && (
            <ServiceInfo color="#767676">{t("QUOTE_NO_SERVICES")}</ServiceInfo>
          )}
          {serviceList.length === 0 && itemsErrorMessage && (
            <ErrorDiv>
              <RequiredMessage>
                <Image
                  src={errorIcon}
                  alt="warning"
                  className="add-quote__quote_action_icon_no_margin"
                />{" "}
                {itemsErrorMessage}
              </RequiredMessage>
            </ErrorDiv>
          )}
        </QuoteServicePadding>
        <MargingDiv>
          <GridRow column="60% 1fr" marginBottom="3px">
            <div>
              {exchangeCurrency.length > 0 && (
                <ExchangeRateConatiner>
                  {exchangeCurrency.map((exchange, exchangeIndex) => {
                    return (
                      <React.Fragment
                        key={"quote-item-exchange-" + exchangeIndex}
                      >
                        <ExchangeRateLabel
                          color={
                            getExchangeError(exchange) !== ""
                              ? "red"
                              : "#f08046"
                          }
                        >
                          {exchangeIndex === 0 ? t("QUOTE_EXCHANGE_RATE") : ""}{" "}
                          ({currencyList[exchange] + " -> " + currency})
                        </ExchangeRateLabel>
                        <TextInput
                          type="text"
                          onChange={(e) => {
                            onExchangeRateChange(e, exchange);
                          }}
                          disabled={false}
                          name="quote-service-exchange-rate-label"
                          id="quote-service-exchange-rate-label"
                          value={getExchangeValue(exchange)}
                          errorStyles={{ "font-style": "italic" }}
                          labelStyles={
                            getExchangeError(exchange) !== ""
                              ? labelStylesError
                              : labelStyles
                          }
                          inputStyles={
                            getExchangeError(exchange) !== ""
                              ? inputStylesError
                              : ExchangeInputStyles
                          }
                          containerStyles={{
                            textAlign: "left",
                            width: "10%",
                          }}
                          error={getExchangeError(exchange)}
                        />
                      </React.Fragment>
                    );
                  })}
                </ExchangeRateConatiner>
              )}
            </div>
            <div>
              <GridRow column="70% 1fr" marginBottom="3px">
                <MarginGridSubItem color="#474747">
                  {t("QUOTE_TOTAL_EXCLUDED_TAX")}
                </MarginGridSubItem>
                {(exchangeCurrency?.length === 0 ||
                  (exchangeCurrency?.length > 0 &&
                    checkAllExchangeHasValue() === 0)) && (
                  <MarginGridSubItem color="#0A4986">
                    {renderPriceWithCurrencyWithoutUnit(
                      addSpace(formData?.totalExcludingTax?.value),
                      currency,
                      currencyPosition
                    )}
                  </MarginGridSubItem>
                )}
                {exchangeCurrency?.length > 0 &&
                  checkAllExchangeHasValue() !== 0 && (
                    <MarginGridSubItem color="#F08046">
                      {renderPriceWithCurrencyWithoutUnit(
                        "--",
                        currency,
                        currencyPosition
                      )}
                    </MarginGridSubItem>
                  )}
                {/* {exchangeCurrency?.length > 0 &&
                  checkAllExchangeHasValue() === 0 && (
                    <MarginGridSubItem color="#0A4986">
                      {renderPriceWithCurrencyWithoutUnit(
                        addSpace(formData.totalExcludingTax.value),
                        currency,
                        currencyPosition
                      )}
                    </MarginGridSubItem>
                  )} */}
              </GridRow>
              <GridRow column="70% 1fr" marginBottom="3px">
                <MarginGridSubItem color="#474747">
                  {t("QUOTE_TOTAL_INCLUDED_TAX")}
                </MarginGridSubItem>
                {(exchangeCurrency?.length === 0 ||
                  (exchangeCurrency?.length > 0 &&
                    checkAllExchangeHasValue() === 0 &&
                    (formData.taxRate.value ||
                      formData.taxRate.value === 0))) && (
                  <MarginGridSubItem color="#0A4986">
                    {renderPriceWithCurrencyWithoutUnit(
                      addSpace(formData.totalIncludingTax.value),
                      currency,
                      currencyPosition
                    )}
                  </MarginGridSubItem>
                )}
                {exchangeCurrency?.length > 0 &&
                  (checkAllExchangeHasValue() !== 0 ||
                    formData.taxRate.value === "") && (
                    <MarginGridSubItem color="#F08046">
                      {renderPriceWithCurrencyWithoutUnit(
                        "--",
                        currency,
                        currencyPosition
                      )}
                    </MarginGridSubItem>
                  )}
                {/* {exchangeCurrency?.length > 0 &&
                  checkAllExchangeHasValue() === 0 &&
                  (formData.taxRate.value || formData.taxRate.value === 0) && (
                    <MarginGridSubItem color="#0A4986">
                      {renderPriceWithCurrencyWithoutUnit(
                        addSpace(formData.totalExcludingTax.value),
                        currency,
                        currencyPosition
                      )}
                    </MarginGridSubItem>
                  )} */}
              </GridRow>
              <GridRow column="70% 1fr" marginBottom="3px">
                <MarginGridSubItem color="#474747">
                  {t("QUOTE_TOTAL_MARGIN")}
                </MarginGridSubItem>
                {(exchangeCurrency?.length === 0 ||
                  (exchangeCurrency?.length > 0 &&
                    checkAllExchangeHasValue() === 0)) && (
                  <MarginGridSubItem color="#0A4986">
                    ({formData?.totalMarginRate?.value + "%"}){" "}
                    {renderPriceWithCurrencyWithoutUnit(
                      addSpace(formData?.totalMargin?.value),
                      currency,
                      currencyPosition
                    )}
                  </MarginGridSubItem>
                )}
                {exchangeCurrency?.length > 0 &&
                  checkAllExchangeHasValue() !== 0 && (
                    <MarginGridSubItem color="#F08046">
                      ({"--" + "%"}){" "}
                      {renderPriceWithCurrencyWithoutUnit(
                        "--",
                        currency,
                        currencyPosition
                      )}
                    </MarginGridSubItem>
                  )}
                {/* {exchangeCurrency?.length > 0 &&
                  checkAllExchangeHasValue() === 0 && (
                    <MarginGridSubItem color="#0A4986">
                      {getConvertedMarginRate()}
                    </MarginGridSubItem>
                  )} */}
              </GridRow>
            </div>
          </GridRow>
        </MargingDiv>
      </QuoteServiceInfo>

      {isSelectSellingPricePopupVisible && (
        <SelectSellingPrice
          onClose={onClose}
          enquiryList={enquiryList}
          siteId={siteId}
          selectedSellingPrice={selectedSellingPrice}
          setSelectedSellingPrice={setSelectedSellingPrice}
          setCurrentSellingPrice={setCurrentSellingPrice}
          editSellingPrice={editSellingPrice}
          addSellingPrice={addNewSellingPrice}
          setEnquiryData={setEnquiryData}
          isLoading={isLoading}
          sellingPriceArray={sellingPriceArray}
          setSellingPriceArray={setSellingPriceArray}
        />
      )}
      {isEditSellingPricePopupVisible && (
        <AddEditSellingPrice
          onClose={closeSellingPriceEditPopup}
          id={currentSellingPrice?.id}
          sellingPriceData={currentSellingPrice}
          enquiryId={currentSellingPrice?.requestId}
          enquiryData={enquiryData}
          countryId={parseInt(siteData?.platformCountryId, 10)}
          onRefreshData={onRefreshData}
          isEditMode
          selectedSolutionsIds={selectedSolutionIds[currentSellingPrice.id]}
        />
      )}
      {isAddSellingPricePopupVisible && (
        <AddEditSellingPrice
          onClose={closeSellingPriceEditPopup}
          enquiryId={enquiryData?.id}
          enquiryData={enquiryData}
          onRefreshData={onRefreshData}
          isEditMode={false}
          selectedSolutionsIds={selectedSolutionIds[currentSellingPrice.id]}
          page="quote"
          isJobsite
          siteData={siteData}
          countryId={parseInt(enquiryData?.site?.platformCountry.id, 10)}
          updateEnquiryInfo={updateEnquiryInfo}
        />
      )}
    </>
  );
};

QuoteServices.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};
QuoteServices.defaultProps = {
  id: null,
};

export default withTranslation()(QuoteServices);
